import classNames from 'classnames';
import { QuoteIcon } from 'routes/essential-workspace/components/quote-status/icon';
import { EssentialWorkflowStatus } from 'routes/essential-workspace/state/model';

import './style.scss';

export function QuoteChip({ status, className }: { status: EssentialWorkflowStatus; className?: string }) {
  return (
    <div className={classNames('quote-chip', `quote-chip-${status}`, className)}>
      <QuoteIcon status={status} size="md" />
    </div>
  );
}
